/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const RefreshButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "common.reload" })}
      css={labellessButtonCss}
      iconName="cached"
      dataCy="refresh-button"
      {...props}
    />
  );
};

export default RefreshButton;
